var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 571,
    height: 569,
    viewBox: "0 0 571 569",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.5 569C443.2 569 571 441.6 571 284.5C571 127.4 443.2 0 285.5 0C127.8 0 0 127.4 0 284.5C0 441.6 127.8 569 285.5 569Z",
    fill: "url(#paint0_linear_51_25824)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M460.7 281.899C471.7 292.299 482.4 302.399 493.4 312.799C492 313.799 491.1 314.399 490.3 314.799C423.5 353.099 356.6 391.399 289.7 429.799C287.8 430.899 286.5 431.099 284.6 429.899C217.6 391.299 150.6 352.799 83.6001 314.299C82.9001 313.899 82.2001 313.499 80.6001 312.399C83.3001 309.999 85.8001 307.999 88.1001 305.799C94.9001 299.099 101.6 292.399 108.2 285.499C110.1 283.499 111.4 283.299 113.9 284.699C170.5 316.899 227.3 348.999 283.9 381.199C286.6 382.799 288.5 382.699 291.2 381.199C347 348.399 402.8 315.799 458.7 283.099C459.5 282.599 460.6 281.999 460.7 281.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M134.1 211.3C144.2 217.1 153.7 222.6 163.3 228.1C203.6 251.4 244 274.8 284.3 298.2C286.7 299.6 288.5 299.7 291 298.2C339 270.1 387.2 242.1 435.3 214.1C436.7 213.3 438.1 212.5 440.1 211.4C440.1 215.5 440.1 219.1 440.1 222.8C440.1 234.1 440.1 245.4 440.1 256.6C440.1 258.8 439.6 260 437.7 261.1C388.3 289.5 339 318 289.6 346.5C287.9 347.5 286.8 347.4 285.1 346.5C235.6 318.2 186.1 290 136.7 261.7C135.6 261 134.2 259.5 134.2 258.4C134.1 243 134.1 227.4 134.1 211.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M192.5 209.7C234.4 185.5 275.9 161.5 317.9 137.3C318 139 318.2 140.2 318.3 141.4C318.6 151.1 318.9 160.9 319 170.6C319 171.8 318.1 173.6 317 174.2C286.5 191.9 256 209.5 225.5 227C224.5 227.5 222.8 227.8 222 227.3C212.2 221.6 202.6 215.8 192.5 209.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M338.1 199.399C338.1 211.299 338.1 222.399 338 233.399C338 234.399 337 235.699 336 236.299C320.3 245.499 304.5 254.499 288.7 263.499C287.9 263.999 286.5 264.299 285.8 263.899C275.9 258.299 266.1 252.399 255.7 246.399C283.2 230.699 310.2 215.299 338.1 199.399Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M287.3 546.6C432.6 546.6 550.4 429.2 550.4 284.4C550.4 139.6 432.6 22.2002 287.3 22.2002C142 22.2002 24.2002 139.6 24.2002 284.4C24.2002 429.2 142 546.6 287.3 546.6Z",
    stroke: "url(#paint1_linear_51_25824)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_25824",
    x1: 298.835,
    y1: -63.8191,
    x2: 272.158,
    y2: 633.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D591FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4792,
    stopColor: "#919CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947,
    stopColor: "#91EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_25824",
    x1: 0.770996,
    y1: 259.638,
    x2: 573.825,
    y2: 309.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImage);
export default __webpack_public_path__ + "static/media/banner-image.cd763ce8f2c48cfd71433889352337b5.svg";
export { ForwardRef as ReactComponent };